// extracted by mini-css-extract-plugin
export default {"alertContainer":"styles_alertContainer__TWuA+"};